var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56828 3.58472H1.65534C0.964042 3.58472 0.398438 4.15032 0.398438 4.84162V13.0115C0.398438 13.3571 0.68124 13.6399 1.02689 13.6399C1.37253 13.6399 1.65534 13.3571 1.65534 13.0115V5.47006C1.65534 5.12442 1.93814 4.84162 2.28379 4.84162H8.56828C8.91393 4.84162 9.19673 4.55881 9.19673 4.21317C9.19673 3.86752 8.91393 3.58472 8.56828 3.58472ZM8.93906 6.4693L11.9745 9.50471C12.207 9.73723 12.339 10.0577 12.339 10.3908V16.1537C12.339 16.845 11.7734 17.4106 11.0821 17.4106H4.16285C3.47155 17.4106 2.91223 16.845 2.91223 16.1537L2.91852 7.35541C2.91852 6.66412 3.47784 6.09851 4.16913 6.09851H8.04667C8.37974 6.09851 8.70025 6.23049 8.93906 6.4693ZM8.56828 10.4977H11.3963L7.93983 7.04119V9.86921C7.93983 10.2149 8.22263 10.4977 8.56828 10.4977Z",
    fill: "#EF2E25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.b0b822832e364742387faea972264e3e.svg";
export { ForwardRef as ReactComponent };